export enum LikeGroup {
  PRODUCT = "PRODUCT",
  MEMBER = "MEMBER",
}
